<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-briefcase"></i> Produto</h3>
      </div>
    </div>
    <ProductAdd v-if="showAdd" ref="ProductAdd" v-on:Back="onBack" />
    <ProductList v-else ref="ProductList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ProductAdd from './components/add/productadd.vue'
import ProductList from './components/list/productlist.vue'

export default {
  name: 'Produto',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ProductAdd,
    ProductList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ProductAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.ProductList.onLoad()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/product/product.vue